import { BookThumb } from '@/components/insights'
import type { SelectOption } from '@/components/ui'
import type { Book } from '@/types'

const STATUS_ICON: Record<string, string> = {
  read: '✅',
  reading: '📖',
  unread: '📚',
  wishlist: '💜',
}

/** Select option for a book: cover, title and author (searchable by both) */
export function bookSelectOption(
  book: Pick<Book, 'id' | 'title' | 'author' | 'cover_url' | 'status'>,
  { showStatus = false }: { showStatus?: boolean } = {}
): SelectOption {
  return {
    value: book.id,
    label: book.title,
    textValue: book.title,
    description: showStatus ? `${STATUS_ICON[book.status] ?? ''} ${book.author}` : book.author,
    leading: <BookThumb src={book.cover_url} title={book.title} size="sm" />,
  }
}
